import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { KnBrBackButtonComponent } from './kn-br-back-button.component';

@NgModule({
    imports: [
        CommonModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrBackButtonComponent: {
                    component: KnBrBackButtonComponent,
                },
            },
        } as CmsConfig),
        KnBrBackButtonComponent,
    ],
    exports: [KnBrBackButtonComponent]
})
export class KnBrBackButtonModule {}
